import { forwardRef, memo, type ReactNode, type Component } from 'react';
import clsx from 'clsx';
// Material UI imports
import Box, { type BoxProps } from '@mui/material/Box';
import CardContent, { type CardContentProps } from '@mui/material/CardContent';
// SCSS imports
import { shadyBg } from '../styles/modules/ItemsGrid.module.scss';
import { section, compactPadding, cardTop, cardBottom, cardNarrow } from './CardSection.module.scss';

type CardSectionProps = {
  readonly dark?: boolean;
  readonly shady?: boolean;
  readonly light?: boolean;
  readonly compact?: boolean;
  readonly top?: boolean | null;
  readonly bottom?: boolean | null;
  readonly narrow?: boolean;
  readonly flex?: boolean;
  readonly className?: string;
  readonly children: ReactNode;
  readonly sx?: CardContentProps['sx'];
};

const CardSection = forwardRef<Component<BoxProps>, CardSectionProps>(({
  children,
  dark = false,
  shady = false,
  light = false,
  compact = false,
  top = false,
  bottom = false,
  narrow = false,
  flex = false,
  className,
  sx
}, ref) => (
  <CardContent
      ref={ref}
      component={Box}
      color={dark || shady || light ? 'text.label' : undefined}
      bgcolor={(dark && 'background.card') || (light && 'background.shady') || undefined}
      display={flex ? 'flex' : undefined}
      alignItems={flex ? 'center' : undefined}
      flexWrap={flex ? 'wrap' : undefined}
      className={clsx(section, className, {
        [compactPadding]: compact,
        [cardTop]: top,
        [cardBottom]: bottom,
        [cardNarrow]: narrow,
        [shadyBg]: shady
      })}
      sx={sx}
  >
    {children}
  </CardContent>
));

CardSection.displayName = 'CardSection';

export default memo(CardSection);
